"use client";

import { Lock } from "@faire/web/slate/icons/foundation/Lock";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

interface IProps {
  hideLockIcon?: boolean;
}

export const LoggedOutUnlockWholesalePriceCta = ({ hideLockIcon }: IProps) => (
  <Row align="center">
    {!hideLockIcon ? (
      <>
        <Lock lockType="foundation" />
        <Spacer width={4} />
      </>
    ) : null}
    <Typography className="underline">
      <StrictLocalMsg
        id="Dob8+8"
        defaultMessage="Unlock wholesale price"
        description={{
          text: "sign up cta for product tiles",
        }}
      />
    </Typography>
  </Row>
);
